<template>
    <div class="container">
        <naturalBasicInfoForm v-if="exitFlag" :exitFlag.sync="exitFlag" :viewFlag.sync="viewFlag"/>
        <naturalBasicInfoView v-if="viewFlag" :exitFlag.sync="exitFlag" :viewFlag.sync="viewFlag" />
    </div>
</template>
<script>
    import naturalBasicInfoForm from './natural-basicInfo-form';
    import naturalBasicInfoView from './natural-basicInfo-view';
    import {mapState} from "vuex";
    export default {
        data(){
            return {
                exitFlag:false,
                viewFlag:false,
            }
        },
        created(){
            this.getBasicInfoMsg();
        },
        activated() {
            this.getBasicInfoMsg();
        },
        mounted(){

        },
        computed:{
            ...mapState({
                id:(state) => state.user.orgId,
                entId:(state) => state.user.userinfo.userId
            })
        },
        components:{
            naturalBasicInfoForm,
            naturalBasicInfoView
        },
        methods:{
            getBasicInfoMsg() { //获取基本信息
                this.$http.post('/personbaseinfo/getbyid?id=' + this.entId).then((res) => {
                    if (res.data.code == 1) {
                        if(res.data.data.state == -1){
                            this.exitFlag = true;
                            this.viewFlag = false;
                        }else{
                            this.exitFlag = false;
                            this.viewFlag = true;
                        }
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>

</style>